var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0859375 10.7891L1.85156 5.5L0.0859375 0.210938L15.9531 5.5L0.0859375 10.7891ZM2.73438 5H11.2969L1.66406 1.78906L2.73438 5ZM1.66406 9.21094L11.2969 6H2.73438L1.66406 9.21094Z","fill":"#333333"}));
}

Send.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none"};

module.exports = Send;

Send.default = Send;
